import {LitElement, html, css} from 'lit';
import {SignalWatcher} from '@lit-labs/preact-signals';
import {authService} from '../../auth/auth.service.js';
import {authChecking, isLoggedIn} from '../../auth/auth.store.js';
import '../../components/clam-login/clam-login.js';
import '../../components/clam-admin-shell/clam-admin-shell.js';
import '../../components/clam-session-expired/clam-session-expired.js';
import '../../../components/clam-spinner.js';

function isExpiredRoute(): boolean {
    return typeof window !== 'undefined' && window.location.pathname === '/sesion-expirada';
}

export class ClamAdminApp extends SignalWatcher(LitElement) {
    static styles = css`
        :host {
            display: block;
            min-height: 100vh;
            font-family: var(--clam-font, 'Inter', system-ui, sans-serif);
        }

        .loader {
            position: fixed;
            inset: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            background: var(--clam-surface-soft, #f5f6f8);
        }
    `;

    private _booted = false;

    connectedCallback(): void {
        super.connectedCallback();
        authService.restoreSession();
        if (!this._booted) {
            this._booted = true;
            void this._boot();
        }
    }

    private async _boot(): Promise<void> {
        await authService.checkSession();
        authChecking.value = false;
    }

    render() {
        if (isExpiredRoute()) {
            return html`<clam-session-expired></clam-session-expired>`;
        }
        if (authChecking.value) {
            return html`<div class="loader"><clam-spinner size="lg"></clam-spinner></div>`;
        }
        if (!isLoggedIn.value) {
            return html`<clam-login></clam-login>`;
        }
        return html`<clam-admin-shell></clam-admin-shell>`;
    }
}

customElements.define('clam-admin-app', ClamAdminApp);

declare global {
    interface HTMLElementTagNameMap {
        'clam-admin-app': ClamAdminApp;
    }
}
